module.exports = __webpack_public_path__ + "img/icon_bpbj.567e59ff.png";